import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useStoreActions } from '~/store/store-context';
export const useApproveAdHocInvoice = ()=>{
    const { api } = useStoreActions();
    const { mutate, isLoading } = useMutationState({
        mutationFn: (param)=>{
            let { invoiceId, fundingSourceId, approvedLegalTermsId } = param;
            return api.invoice.approveAdHoc({
                invoiceId,
                fundingSourceId,
                approvedLegalTermsId
            });
        }
    });
    return {
        approveAdHocInvoice: mutate,
        isLoading
    };
};
